import { Content } from "./Content";
import { SubmitForm } from "./SubmitForm";
export { Content, SubmitForm };
